import {Children, useEffect, useRef, useState} from "react";
import Modal from 'react-modal';
import classnames from 'classnames';

import montasLogo from "../images/montas_logo_no_text.svg";
import montasLogoMinimalistic from "../images/montas_logo_minimalistic.svg";
import brandsLogos from "../images/marken.svg";
import {MatchMedia} from "./MatchMedia";
import hotkeys from "hotkeys-js";
import {isFunction, times} from "lodash";
import SuccessScreen from "./SuccessScreen";

function FormWrapper({url, formId, files, onSubmit, onSuccess, onError, children}) {

    const formRef = useRef();

    const [fieldsetIndex, setFieldsetIndex] = useState(0);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalBody, setModalBody] = useState('');
    const [isPending, setPending] = useState(false);
    const [isSuccess, setSuccess] = useState(false);

    const fieldsetsCount = Children.count(children);

    const prevFieldset = () => {
        if(!isPending){
            setFieldsetIndex(Math.max(fieldsetIndex - 1, 0));
        };
    };

    // if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        for(let i=1; i<=fieldsetsCount; i++){
            hotkeys(`ctrl+${i}`, function(event){
                event.preventDefault();
                formRef.current.scrollTop = 0;
                setFieldsetIndex(i-1);
            });
        }
    // }

    const onFormSubmit = async (event) => {
        event.preventDefault();

        if(isPending){
            return;
        }

        if(isFunction(onSubmit)){
            onSubmit();
        }

        setPending(true);

        try{
            const formData = new FormData(formRef.current);

            files.forEach((file,index) => {
                formData.append(`file_${index}`, file);
            });


            const response = await fetch(url, {
                method: "POST",
                // headers: {'content-type': 'multipart/form-data'},
                body: formData,
            });

            const data = await response.json();

            if(data.message){
                // setModalBody(data.message);
                // setModalIsOpen(true);

                if(data.status === 'success'){
                    setSuccess(true);
                    if(isFunction(onSuccess)){
                        onSuccess();
                    }
                }

                if(data.status === 'error' && isFunction(onError)){
                    onError(data.message);
                }
            }

            setPending(false);
        }
        catch (error){
            // setModalBody(error);
            // setModalIsOpen(true);
            setPending(false);
        }
    }

    useEffect(() => {
        const formElement = formRef.current;
        const nextButtons = formElement.querySelectorAll('.next-fieldset');

        nextButtons.forEach((button, i) => {
            button.addEventListener('click', (event) => {
                event.preventDefault();
                formRef.current.scrollTop = 0;
                setFieldsetIndex(i + 1);
            });
        });
    }, []);

    return <div className={'form-wrapper'}>
        <header>
            <div className="back">
                {!isSuccess && (
                    <button onClick={prevFieldset} disabled={fieldsetIndex===0}>&lt; zurück</button>
                )}
            </div>

            <div className="logo">
                <MatchMedia query={'(min-width: 720px)'}>
                    <MatchMedia.Success>
                        <img src={montasLogo} alt="Montas Logo"/>
                    </MatchMedia.Success>
                    <MatchMedia.Failed>
                        <img src={montasLogoMinimalistic} alt="Montas Logo - O-Symbol"/>
                    </MatchMedia.Failed>
                </MatchMedia>
            </div>

            {/*<div className="step">*/}
            {/*    <span className="current">{fieldsetIndex + 1}</span> / <span className="total">{fieldsetsCount}</span>*/}
            {/*</div>*/}

            <div className="progress">
                <div className="markers">
                    {times(fieldsetsCount-1, (i)=><span key={i}></span>)}
                </div>
                <div className="bar" style={{width: 100*(fieldsetIndex + 1)/fieldsetsCount+'%'}}></div>
            </div>
        </header>

        {isSuccess && (
            <div className={'form-wrapper success'}>
                <SuccessScreen/>
            </div>
        )}

        {!isSuccess && (
            <form ref={formRef} onSubmit={onFormSubmit} id={formId} className={classnames({pending: isPending})}>
                {Children.map(children, (child, i) => {
                    return <div className={classnames('fieldset-wrapper', {'is-selected':i===fieldsetIndex})}>
                        {child}
                    </div>;
                })}
            </form>
        )}



        <div className="brands">
            <hr/>
            <img src={brandsLogos} alt="Marken"/>
        </div>

        <Modal
            isOpen={modalIsOpen}
            onRequestClose={() => setModalIsOpen(false)}
            contentLabel={'Debug'}
            style={{overlay: {zIndex: 100}}}
        >
            <h2>Debug</h2>

            <div dangerouslySetInnerHTML={{__html: modalBody}}></div>

            <button onClick={() => setModalIsOpen(false)}>Schließen</button>
        </Modal>
    </div>;
}

export default FormWrapper;